module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/75/assets/images/cbf942c0f075aa22032816554a17c790.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_vidhelp.svg
// module id = F0TD
// module chunks = 0